import { GlobalCodeUnifyContentPackageType } from '@csp/csp-common-content-definitions';
import { LangCode, Language } from '@csp/csp-common-model';
import { StringUtil } from '@csp/csp-common-util';
import { LanguageNames } from '../model/LanguageNames';

const defaultLanguage: Language = { code: '', name: '' };

const from = (globalCodePackage: GlobalCodeUnifyContentPackageType): LanguageNames => {
  const languages =
    globalCodePackage.global_code.flatMap(
      code => code.languages?.map(language => ({ code: language.code ?? '', name: language.name ?? '' })) ?? [],
    ) ?? [];

  const getLanguage = (langCode: LangCode): Language =>
    languages.find(language => StringUtil.equalsInsensitive(language.code, langCode)) ?? defaultLanguage;

  const getLanguages = (langCode: LangCode[]): Language[] => langCode.map(getLanguage);

  return {
    languages,
    getLanguage,
    getLanguages,
  };
};

export const LanguageNamesMapper = {
  from,
};
